import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';

export const exchangeQueryKey = createQueryKeys('exchange', {
  info: {
    queryFn: async () => {
      const { data } = await serviceApi.user.getUserPersonalInformation(
        withServiceRequestDefaults(),
      );
      return data;
    },
    queryKey: null,
  },
});

export type ExchangeQueryKey = inferQueryKeys<typeof exchangeQueryKey>;
